import React, {FC} from 'react'
import ReactSelect, {GroupTypeBase, Props, Styles} from 'react-select'
import {makeStyles, Typography} from '@material-ui/core'
import { observer } from 'mobx-react';
import { LNG } from '../Services/LanguageService';

export type Option = {
    value: string;
    label: string;
};

type SelectProps = {
    isInvalid?: boolean;
    label?: string;
}

const useStyles = makeStyles(theme => ({
    label: {
        fontSize: 12,
        marginBottom: theme.spacing(0),
    },
    select: {
        // "rs-select2__control": {}
    },
}))

type SingleSelectProps = Props<Option, false, GroupTypeBase<Option>> & SelectProps;
type MultiSelectProps = Props<Option, true, GroupTypeBase<Option>> & SelectProps;
const ReactSelectStyles = (hasError: boolean): Partial<Styles<Option, false, GroupTypeBase<Option>>> => ({
    control: (base) => ({
        ...base,
        ...{minHeight: 'none', borderRadius: 4, fontSize: 12},
        ...(hasError ? {border: '2px solid red'} : {border: base.border}),
    }),
    dropdownIndicator: base => ({...base, padding: '2px'}),
    input: base => ({...base, lineHeight: '17px'}),
    valueContainer: base => ({...base, padding: '0 8px'}),
    clearIndicator: base => ({...base, padding: 0, fontSize: '12px'}),
    multiValue: base => ({...base, margin: '0 2px 0 0'}),
    menu: base => ({...base, zIndex: 20, fontSize: 12}),
    menuPortal: base => ({...base, zIndex: 20}),
})
const SingleReactSelectStyles = ReactSelectStyles as (hasError: boolean) => Partial<Styles<Option, false, GroupTypeBase<Option>>>
const MultyReactSelectStyles = ReactSelectStyles as (hasError: boolean) => Partial<Styles<Option, true, GroupTypeBase<Option>>>

export const Select: FC<SingleSelectProps> = observer((props) => {
    const {isInvalid, label} = props
    const classes = useStyles()
    return (
        <>
            {label && <Typography className={classes.label}>{label}</Typography>}
            <ReactSelect
                className={classes.select}
                classNamePrefix={'rs-select2'}
                placeholder={LNG.Text('Dashboard.26')}
                {...props}
                styles={{...SingleReactSelectStyles(!!isInvalid), ...(props.styles || {})}}
                menuPortalTarget={document.body}
            />
        </>
    )
})

export const MultiSelect: FC<MultiSelectProps> = (props) => {
    const {isInvalid, label} = props
    const classes = useStyles()
    return (
        <>
            {label && <Typography className={classes.label}>{label}</Typography>}
            <ReactSelect
                className={classes.select}
                isMulti
                placeholder={LNG.Text('Dashboard.26')}
                classNamePrefix={'rs-select2'}
                {...props}
                styles={{...MultyReactSelectStyles(!!isInvalid), ...(props.styles || {})}}
                menuPortalTarget={document.body}
            />
        </>

    )
}

export function getSelectOptions<T>(data: T[], objLabel: keyof T, objValue: keyof T): Option[] {
    return data.map(el => {
        const label = String(el[objLabel] || LNG.Text('Dashboard.25'))
        const value = String(el[objValue])
        return {label, value}
    })
}